import React from 'react';

export class UserCapabilities {
  private userCanHover = false;

  constructor() {
    const mouseOverListener = () => {
      this.userCanHover = true;
      window.removeEventListener('mouseover', mouseOverListener, false);
    };
    window.addEventListener('mouseover', mouseOverListener, false);
  }

  canHover() {
    return this.userCanHover;
  }

  isMobile() {
    // TODO: Something better?
    return window.innerWidth <= 500;
  }
}

export const UserCapabilitiesContext = React.createContext<UserCapabilities>(
  /* default= */ undefined,
);
